export const FORUM_LIST_REQUEST = 'FORUM_LIST_REQUEST';
export const FORUM_LIST_SUCCESS = 'FORUM_LIST_SUCCESS';
export const FORUM_LIST_FAILURE = 'FORUM_LIST_FAILURE';

export const FORUM_LIST_PUBLISH_REQUEST = 'FORUM_LIST_PUBLISH_REQUEST';
export const FORUM_LIST_PUBLISH_SUCCESS = 'FORUM_LIST_PUBLISH_SUCCESS';
export const FORUM_LIST_PUBLISH_FAILURE = 'FORUM_LIST_PUBLISH_FAILURE';

export const FORUM_LIST_COLLECT_REQUEST = 'FORUM_LIST_COLLECT_REQUEST';
export const FORUM_LIST_COLLECT_SUCCESS = 'FORUM_LIST_COLLECT_SUCCESS';
export const FORUM_LIST_COLLECT_FAILURE = 'FORUM_LIST_COLLECT_FAILURE';

export const FORUM_ACTION_REMOVE_REQUEST = 'FORUM_ACTION_REMOVE_REQUEST';
export const FORUM_ACTION_REMOVE_SUCCESS = 'FORUM_ACTION_REMOVE_SUCCESS';
export const FORUM_ACTION_REMOVE_FAILURE = 'FORUM_ACTION_REMOVE_FAILURE';

export const FORUM_ACTION_SET_REQUEST = 'FORUM_ACTION_SET_REQUEST';
export const FORUM_ACTION_SET_SUCCESS = 'FORUM_ACTION_SET_SUCCESS';
export const FORUM_ACTION_SET_FAILURE = 'FORUM_ACTION_SET_FAILURE';

export const FORUM_ASS_WORD_REQUEST = 'FORUM_ASS_WORD_REQUEST';
export const FORUM_ASS_WORD_SUCCESS = 'FORUM_ASS_WORD_SUCCESS';
export const FORUM_ASS_WORD_FAILURE = 'FORUM_ASS_WORD_FAILURE';

export const FORUM_UPLOAD_PARAMS_REQUEST = 'FORUM_UPLOAD_PARAMS_REQUEST';
export const FORUM_UPLOAD_PARAMS_SUCCESS = 'FORUM_UPLOAD_PARAMS_SUCCESS';
export const FORUM_UPLOAD_PARAMS_FAILURE = 'FORUM_UPLOAD_PARAMS_FAILURE';

export const FORUM_INFO_REQUEST = 'FORUM_INFO_REQUEST';
export const FORUM_INFO_SUCCESS = 'FORUM_INFO_SUCCESS';
export const FORUM_INFO_FAILURE = 'FORUM_INFO_FAILURE';

export const FORUM_CONTENT_REQUEST = 'FORUM_CONTENT_REQUEST';
export const FORUM_CONTENT_SUCCESS = 'FORUM_CONTENT_SUCCESS';
export const FORUM_CONTENT_FAILURE = 'FORUM_CONTENT_FAILURE';

export const FORUM_SUBMIT_REQUEST = 'FORUM_SUBMIT_REQUEST';
export const FORUM_SUBMIT_SUCCESS = 'FORUM_SUBMIT_SUCCESS';
export const FORUM_SUBMIT_FAILURE = 'FORUM_SUBMIT_FAILURE';

export const FORUM_DELETE_REQUEST = 'FORUM_DELETE_REQUEST';
export const FORUM_DELETE_SUCCESS = 'FORUM_DELETE_SUCCESS';
export const FORUM_DELETE_FAILURE = 'FORUM_DELETE_FAILURE';

export const FORUM_COMMENT_ADD_REQUEST = 'FORUM_COMMENT_ADD_REQUEST';
export const FORUM_COMMENT_ADD_SUCCESS = 'FORUM_COMMENT_ADD_SUCCESS';
export const FORUM_COMMENT_ADD_FAILURE = 'FORUM_COMMENT_ADD_FAILURE';

export const FORUM_COMMENT_ZAN_REQUEST = 'FORUM_COMMENT_ZAN_REQUEST';
export const FORUM_COMMENT_ZAN_SUCCESS = 'FORUM_COMMENT_ZAN_SUCCESS';
export const FORUM_COMMENT_ZAN_FAILURE = 'FORUM_COMMENT_ZAN_FAILURE';

export const FORUM_COMMENT_REVIEW_REQUEST = 'FORUM_COMMENT_REVIEW_REQUEST';
export const FORUM_COMMENT_REVIEW_SUCCESS = 'FORUM_COMMENT_REVIEW_SUCCESS';
export const FORUM_COMMENT_REVIEW_FAILURE = 'FORUM_COMMENT_REVIEW_FAILURE';

export const FORUM_COMMENT_LIST_REQUEST = 'FORUM_COMMENT_LIST_REQUEST';
export const FORUM_COMMENT_LIST_SUCCESS = 'FORUM_COMMENT_LIST_SUCCESS';
export const FORUM_COMMENT_LIST_FAILURE = 'FORUM_COMMENT_LIST_FAILURE';

export const FORUM_COMMENT_GRADE_REQUEST = 'FORUM_COMMENT_GRADE_REQUEST';
export const FORUM_COMMENT_GRADE_SUCCESS = 'FORUM_COMMENT_GRADE_SUCCESS';
export const FORUM_COMMENT_GRADE_FAILURE = 'FORUM_COMMENT_GRADE_FAILURE';

export const FORUM_COMMENT_LOADING = 'FORUM_COMMENT_LOADING';
export const FORUM_COMMENT_REVIEW_SHOW = 'FORUM_COMMENT_REVIEW_SHOW';

export const FORUM_COMMENT_LIST_UPDATE = 'FORUM_COMMENT_LIST_UPDATE';
export const FORUM_COMMENT_LIST_COLLAPSE = 'FORUM_COMMENT_LIST_COLLAPSE';

export const GUIDE_CONTENT = {
  1: {
    desc: '提问',
    title:
      '请简明扼要地填写您的标题，如：Photoshop和美图秀秀哪个好用？有没有可以无损切割视频的软件？',
    text: `1.	请简明扼要地填写您的标题，如<br />
     &nbsp; &nbsp; 1)	Photoshop和美图秀秀哪个好用？<br />
    2.	请清晰准确地描述您的问题，如<br />
    &nbsp; &nbsp; 1)	平时偶尔需要调整一些自己拍的图片，用哪个方便？<br />
    3.	与软件使用相关的具体问题可以适当添加图片<br />
    4.	涉及到具体的应用时可以在底部添加相关应用<br />
    5.	高质量的提问有机会被官方添加置顶<br />
    6.	请勿发表违反国家法律法规的内容<br />
    7.	请理性提问、和谐相处，切勿谩骂、人身攻击`,
    type: 1,
  },
  2: {
    desc: '分享',
    title:
      '请简明扼要地填写您要分享的内容，如网盘下载不限速的5种方法；1分钟快速制作视频局部放大效果',
    text: `1.	请简明扼要地填写您要分享的内容，如<br />
    &nbsp; &nbsp;1)	网盘下载不限速的5种方法<br />
    2.	请详细描述您想要与大家分享的经验，这包括<br />
    &nbsp; &nbsp;1)	基本的概况
    &nbsp; &nbsp;2)	需要的软件
    &nbsp; &nbsp;3)	具体的内容
    &nbsp; &nbsp;4)	经验总结<br />
    3.	在分享的内容中鼓励添加图片内容，以更加清晰展示分享内容<br />
    4.	涉及到具体的应用时可以在底部添加相关应用<br />
    6.	请勿发表违反国家法律法规的内容<br />
    7.	请理性发帖、和谐相处，切勿谩骂、人身攻击<br />
    `,
    type: 2,
  },
};
